<template>
  <LeadLink
    :call-target-id="callTargetId"
    tag="div"
    class="draft-reminder-item"
  >
    <div class="date">
      {{ callBackUpdatedAt }}
    </div>
    <div class="company-name">
      {{ item.companyName }}
    </div>
    <div class="subject">
      {{ $t('draftMailReminder.subject', {subject: item.subject}) }}
    </div>
  </LeadLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { MailRemindItem } from '@/api/openapi';
import LeadLink from '@/components/organisms/user/general/LeadLink.vue';
import { formatDate } from '@/utils/date-time';

type TProps = {
  item: MailRemindItem;
}

const props = withDefaults(defineProps<TProps>(), {});

const callTargetId = computed(() => {
  return props.item.callTargetId;
});

const callBackUpdatedAt = computed(() => {
  return formatDate(props.item.updatedAt);
});
</script>

<style lang="scss" scoped>
.draft-reminder-item {
  display: flex;
  color: $textcolor-base;
  text-decoration: none;
  padding: $basespace-200;
  height: 74px;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid $bdcolor-light;
  width: 100%;

  &:hover {
    background-color: $bgcolor-base;
  }
}
.date {
  color: $textcolor-light;
  font-size: $fontsize-200;
  width: 100px;
  min-width: 100px;
  margin: 0 $basespace-400 0 $basespace-200;
}
.company-name {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: $basespace-700;
}
.subject {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: $basespace-500;
}
</style>
